import type { ReactNode } from 'react'
import { formatRelative, fromLocalInput, localZoneName, toLocalInput } from '@/lib/time'
import { Field } from './Field'
import { SlotPicker } from './SlotPicker'

export interface DateTimeFieldProps {
  label: ReactNode
  /** The slot as the server has it: a UTC ISO string, or null for none. */
  value: string | null | undefined
  /** Called with a UTC ISO string, or null when there is no slot. */
  onChange: (iso: string | null) => void
  hint?: ReactNode
  error?: ReactNode
  required?: boolean
  disabled?: boolean
  className?: string
}

/** A labelled slot. The picker shows the browser's local time; what leaves
 *  this component is always UTC ISO (`fromLocalInput`), which is what the
 *  server compares slots in. */
export function DateTimeField({ label, value, onChange, hint, error, required, disabled, className }: DateTimeFieldProps) {
  const zone = `${localZoneName()} 기준`
  return (
    <Field
      label={label}
      hint={hint ?? (value ? `${zone} · ${formatRelative(value)}` : zone)}
      error={error}
      required={required}
      className={className}
    >
      <SlotPicker
        label={typeof label === 'string' ? label : '예약 시각'}
        value={toLocalInput(value)}
        disabled={disabled}
        onChange={(local) => onChange(fromLocalInput(local))}
      />
    </Field>
  )
}
